/* eslint-disable @typescript-eslint/naming-convention */
import { BaseModel } from '../base.model';
import { FileDataModel } from './fileData-model';

export class CertificationModel extends BaseModel {
  KeyID: number;
  HRRef = '';
  Code = '';
  CertDate: Date;
  ExpireDate: Date;
  SkillTester = '';
  Score?: number;
  udScore = '';
  udBckResult = '';
  udSkillScore = '';
  bActive = true;
  editable = false;
  showFiles: boolean;
  isSaving = false;
  isNewItem = false;
  Delete = false;
  udModel: string;
  udMake: string;
  AudioType: string;
  Notes: string;

  Files: FileDataModel[] = [];

  ProspectID?: string;
  ProspectCertificationID?: string;

  // Bug 35872: assign after the field initialisers (super(o) assigned before them, so they overwrote isNewItem,
  // editable, bActive, etc.), so caller values win.
  constructor(o = null) {
    super();
    if (o) {
      Object.assign(this, o);
    }
  }
}
